module.exports = __webpack_public_path__ + "static/logo_oms_blue.8a05cb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_oms_blue.png
// module id = 358
// module chunks = 95715928098905 114276838955818